import { http } from "../_services/http";
import { config } from "../_config/_config";
export const api = {
  getList: () => {
    return http.get({
      data: {},
      url: config._api("getlistall"),
    });
  },
  fetchProviderNumber: () => {
    return http.get({
      data: {},
      url: config._api("sms/provider")
    });
  },
  deleteFile : (data)=>{ 
    return http.post({
      data: data,
      url: config._api("applicant/deletefile"),
    });
  },
  login: (data) => {
    return http.post({
      data: data,
      url: config._api("applicant/login"),
    });
  },
  getaplications: () => {
    return http.get({
      url: config._api("applicant/getapplications"),
    });
  },
  save: (data) => {
    return http.post({
      data: data,
      url: config._api("applicant/save"),
    });
  },
  getaplicationDeail: (data) => {
    var url = "applicant/applicantdetails";
    if (data.hash) {
      url += "/" + data.hash;
    }
    return http.get({
      url: config._api(url),
    });
  },
  requestEditAccess: () => {
    return http.post({
      url: config._api("applicant/request-edit-access"),
    });
  },
};
